import React from 'react';

export const CircleTabs = ({ activeTab, setActiveTab }) => {
  return (
    <div 
      className="flex gap-4 mb-6 p-1 rounded-full"
      style={{ background: '#F9F4F0' }}
    >
      <button
        onClick={() => setActiveTab('wall')}
        className={`flex-1 py-2 px-4 rounded-full text-sm transition-all ${activeTab === 'wall' ? 'scale-[1.02]' : ''}`}
        style={{ 
          background: activeTab === 'wall' ? 'rgba(201,168,76,0.15)' : 'transparent',
          color: activeTab === 'wall' ? '#C9A84C' : '#6B6878',
          fontFamily: 'Jost, sans-serif'
        }}
        data-testid="tab-wall"
      >
        Sharing Wall
      </button>
      <button
        onClick={() => setActiveTab('threads')}
        className={`flex-1 py-2 px-4 rounded-full text-sm transition-all ${activeTab === 'threads' ? 'scale-[1.02]' : ''}`}
        style={{ 
          background: activeTab === 'threads' ? 'rgba(201,168,76,0.15)' : 'transparent',
          color: activeTab === 'threads' ? '#C9A84C' : '#6B6878',
          fontFamily: 'Jost, sans-serif'
        }}
        data-testid="tab-threads"
      >
        Discussions
      </button>
    </div>
  );
};
